import React, { useEffect, useState } from "react";
import { AccordionSummary, AccordionDetails, Typography, Box, Button, FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material'
import CustomAccordion from '../Accordian/accordian'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "../../assets/styles/ag-grid-custom-theme.css"
import { AvailableUnit, UnitPriceGroupPromotion } from '../../models/AvailableUnits';
import { useGetAvailableUnitsDataQuery, useGetOperatorGuidesQuery } from '../../api/endpoints/apiConfig';
import { useNavigate, useParams } from 'react-router-dom';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import './../../assets/styles/dashboardpage.css';
import { toast } from 'react-toastify';
import CircularProgress from "@mui/material/CircularProgress";

import { facility } from '../../models/DashboardInformation';
interface FacilityInformationProps {
    data: facility | null;
}
const InventoryPricingPromotion: React.FC<FacilityInformationProps> = ({ data }) => {
    const navigate = useNavigate();
    const params = useParams();
    const facilityId = params?.facilityid;
    const operatorId = sessionStorage.getItem('operatorId');
    const { data: responseData, isLoading, isFetching, isError, refetch } = useGetAvailableUnitsDataQuery(facilityId ? parseInt(facilityId) : 0);
    const { data: FacilityOperatorAlerts } = useGetOperatorGuidesQuery(operatorId ? parseInt(operatorId) : 0);
    const [selectedPromoByRowId, setSelectedPromoByRowId] = useState<Record<number, string>>({});
    const handleCreateReservation = (params: any) => {
        const data = params.row;
        navigate('/CreateReservation', { state: { data } }); // Navigate to the Facility Search page
    };
    useEffect(() => {
        if (facilityId) {
            setSelectedPromoByRowId({});
            refetch();
        }
    }, [facilityId, refetch]); // Add refetch to the dependency array
    const SettingData = sessionStorage.getItem('setting');
    const Settings = SettingData ? JSON.parse(SettingData) : [];
    const IsRent = Settings.can_rent;
    const Isreserve = Settings.can_reserve;

    const formatUnitFeatures = (unit: {
        floor?: number;
        inside?: number;
        drive_up?: number;
        climate?: number;
        air_cooled?: number;
        heated?: number;
        elevator?: number;
        stair_access?: number;
    } | null | undefined): string => {
        if (!unit) return '';
        const features: string[] = [];
        if (unit.floor === 1) features.push('First Floor');
        if (unit.floor !== undefined && unit.floor > 1) features.push('Upper');
        if (unit.inside === 1) features.push('Inside');
        if (unit.drive_up === 1) features.push('Drive Up');
        if (unit.climate === 1) features.push('Climate');
        if (unit.air_cooled === 1) features.push('Air Cooled');
        if (unit.heated === 1) features.push('Heated');
        if (unit.elevator === 1) features.push('Elevator Access');
        if (unit.stair_access === 1) features.push('Stair Access');
        return features.join(', ');
    };

    const handleRentReservation = (params: any) => {
        debugger;
        if (!params || !params.row) {
            toast.error("Invalid parameters passed to handleRentReservation");
            return;
        }

        const data = params.row;
        // Format unitSize to remove HTML tags and keep only the size
        const formattedUnitSize = `${data.width > 0 ? data.width + "' x " + data.length + "'" : data.length + "'"}`;
        // Prepare the data to send to the Rent component
        //console.log("*************data", data);
        const rentalData = {
            unitSize: formattedUnitSize,
            features: formatUnitFeatures(data),
            rent: data.price,
            promotion: data.promotion || 'No Promo',
            facilityId: data.facility_id,
            externalUnitId: data.external_unit_id,
            externalPromotionId: data.external_promotion_id,
            price_formatted: data.price_formatted,
            dealId: "",
            external_typeId: data.external_type_id,
            external_type_name: data.productType,
            is_insurable: data.is_insurable ?? null,
            width: data.width,
            length: data.length,
            inside: data.inside ?? 0,
            drive_up: data.drive_up ?? 0,
            climate: data.climate ?? 0,
            air_cooled: data.air_cooled ?? 0,
            heated: data.heated ?? 0,
            elevator: data.elevator ?? 0,
            stair_access: data.stair_access ?? 0,
            units: data.units ?? [],
        };
        navigate(`/rent/${data.facility_id}/unit/${data.external_unit_id}/promo/${data.external_promotion_id}`, {
            state: { rentalData }
        });
    };
    // Define columns for the grid
    const colDefs: GridColDef[] = [
        {
            field: 'unitSize',
            headerName: 'Unit Size',
            flex: 1,
            minWidth: 250,
            headerAlign: 'center',  // Center the header text
            align: 'center',        // Center the cell text horizontally
            renderCell: (params) => (
                <div
                    className="gridCell"  // Use the class defined in your CSS
                    dangerouslySetInnerHTML={{ __html: params.value }}
                />
            ),
        },
        {
            field: 'productType',
            headerName: 'Product Type',
            flex: 1,
            minWidth: 150,
            headerAlign: 'center',
            align: 'center',
            cellClassName: 'inventory-grid-vcentered-cell',
        },
        {
            field: 'price',
            headerName: 'Rate',
            flex: 1,
            maxWidth: 80,
            headerAlign: 'center',
            align: 'center',
            cellClassName: 'inventory-grid-vcentered-cell',
        },
        {
            field: 'promotion',
            headerName: 'Promotion',
            flex: 1,
            minWidth: 180,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            cellClassName: 'inventory-grid-vcentered-cell',
            renderCell: (params) => {
                const promotions: UnitPriceGroupPromotion[] = params.row.promotions || [];
                if (promotions.length === 0) {
                    return params.row.promotion || 'No Promo';
                }
                return (
                    <FormControl
                        size="small"
                        fullWidth
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Select
                            value={String(params.row.external_promotion_id || promotions[0].id)}
                            onChange={(e: SelectChangeEvent) => {
                                setSelectedPromoByRowId((prev) => ({
                                    ...prev,
                                    [params.row.id]: e.target.value,
                                }));
                            }}
                            displayEmpty
                            sx={{ fontSize: '0.875rem' }}
                        >
                            {promotions.map((promo) => (
                                <MenuItem key={promo.id} value={String(promo.id)}>
                                    {promo.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            },
        },
        {
            field: 'total_vacant',
            headerName: 'Available',
            flex: 1,
            maxWidth: 100,
            headerAlign: 'center',
            align: 'center',
            cellClassName: 'inventory-grid-vcentered-cell',
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            maxWidth: 200, // Set a minimum width for the action column
            headerAlign: 'center',
            sortable: false,
            align: 'center',
            renderCell: (params) => (
                <div className="buttonContainer">
                    <div className="buttonGroup">
                        <Button size="small" variant="contained" disabled={!Isreserve} onClick={() => handleCreateReservation(params)}>
                            Reserve
                        </Button>
                        <Button size="small"
                            variant="contained"
                            disabled={!IsRent}
                            onClick={() => handleRentReservation(params)}>Rent</Button>
                    </div>
                </div>
            ),
        },
    ];
    // Prepare row data
    const availableUnits: AvailableUnit[] = responseData?.available_units || [];
    const rowData = availableUnits.map(unit => {
        const promotions = unit.promotions ?? [];
        const defaultPromoId = promotions[0]?.id != null
            ? String(promotions[0].id)
            : (unit.external_promotion_id ? String(unit.external_promotion_id) : '0');
        const selectedPromoId = selectedPromoByRowId[unit.id] ?? defaultPromoId;
        const selectedPromo = promotions.find((p) => String(p.id) === selectedPromoId) ?? promotions[0] ?? null;
        const resolvedPromoId = selectedPromo ? String(selectedPromo.id) : defaultPromoId;
        return {
            id: unit.id,
            unitSize: `${unit.width > 0 ? unit.width + "' x " + unit.length + "'" : unit.length + "'"}
            <br/>${formatUnitFeatures(unit)}`,
            productType: unit.type_name,
            price: `$${unit.price.toFixed(2)}`,
            promotion: selectedPromo?.name || unit.promotion_text || 'No Promo',
            facility_id: unit.facility_id,
            external_unit_id: unit.external_unit_id,
            width: unit.width,
            length: unit.length,
            area: unit.area,
            floor: unit.floor,
            price_formatted: unit.price_formatted,
            external_promotion_id: resolvedPromoId,
            promotion_text: selectedPromo?.name || unit.promotion_text,
            promotions,
            external_type_id: unit.external_type_id,
            type_name: unit.type_name,
            is_insurable: unit.is_insurable ?? null,
            alarm: unit.alarm,
            power: unit.power,
            inside: unit.inside,
            drive_up: unit.drive_up ?? 0,
            climate: unit.climate,
            air_cooled: unit.air_cooled ?? 0,
            heated: unit.heated ?? 0,
            elevator: unit.elevator ?? 0,
            stair_access: unit.stair_access ?? 0,
            mobile: unit.mobile,
            total_units: unit.total_units,
            total_occupied: unit.total_occupied,
            total_vacant: unit.total_vacant,
            total_reserved: unit.total_reserved,
            units: unit.units ?? [],
            created_at: unit.created_at,
            updated_at: unit.updated_at,
        };
    });

    if (!data) {
        return (
            <CustomAccordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography variant="h3" color="text.secondary">Inventory, Pricing and Promotions
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    No data found
                </AccordionDetails>
            </CustomAccordion>
        );
    }
    const removeHtmlTags = (text: string | null | undefined): string => {
        if (!text) {
            return ''; // Return an empty string for null or undefined input
        }
        // Decode HTML entities and normalize spaces
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        const decodedText = textArea.value.replace(/\s+/g, ' ').trim();

        return decodedText;
    };
    const callsxript = data?.guides || [];
    const OperatorAlert = FacilityOperatorAlerts?.guides || [];
    return (
        <CustomAccordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                <Box display="flex" alignItems="center" width="100%">
                    <Typography variant="h3" color="text.secondary" flexGrow={1}>
                        Inventory, Pricing and Promotions
                    </Typography>
                    {(isLoading || isFetching) && (
                        <CircularProgress size={20} sx={{ ml: 2 }} />
                    )}
                </Box>
            </AccordionSummary>

            <AccordionDetails>
                {(callsxript[0]?.facility_pricing_notes || OperatorAlert[0]?.facility_pricing_notes) && (
                    <Box my={2} p={2.5} bgcolor={'#EBF3FF'}>
                        <Typography
                            color="text.primary"
                            textAlign={'left'}
                            dangerouslySetInnerHTML={{ __html: removeHtmlTags(callsxript[0]?.facility_pricing_notes || OperatorAlert[0]?.facility_pricing_notes || '') }}
                        />
                    </Box>
                )}
                <Box sx={{ width: '100%', overflow: 'auto' }}>
                    {isLoading ? (
                        <Typography>Loading...</Typography>
                    ) : isError ? (
                        <Typography>Error loading available units</Typography>
                    ) : (
                        <DataGrid
                            rows={rowData}
                            columns={colDefs}
                            disableColumnMenu
                            autoHeight
                            getRowHeight={() => 'auto'}
                            getEstimatedRowHeight={() => 88}
                            sx={{
                                '& .inventory-grid-vcentered-cell': {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    py: 1,
                                },
                            }}
                        />
                    )}
                </Box>
            </AccordionDetails>
        </CustomAccordion>
    )
}

export default InventoryPricingPromotion
